export default () => 'Conjugr8 – Learn Spanish, Portuguese & Finnish'
